import { defineFilterSpec, enumField, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { DeviceActivityFilterFormValues, DeviceActivityListFilters } from './types';

/** Single declaration of this tab's list filters, shared by api / export / filter drawer.
 *  Multi-selects join to comma strings on the wire; the two purchase-date bounds are plain
 *  `YYYY-MM-DD` strings, so they are `enumField`s (`rangeField` is numeric-only). Field names are
 *  the backend's, verbatim from `DeviceActivityQuery` on `greenway_api@develop`. */
const spec = defineFilterSpec<DeviceActivityListFilters, DeviceActivityFilterFormValues>([
  text('search'),
  multiField('customerIds'),
  multiField('deviceIds'),
  multiField('categoryIds'),
  rangeField('totalActiveTime'),
  rangeField('avgRuntimePerDay'),
  rangeField('totalAlerts'),
  enumField('purchaseDateFrom'),
  enumField('purchaseDateTo'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
